import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDashlaneComponent } from './simple-icons-dashlane.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDashlaneComponent ],
    exports:      [ SimpleIconsDashlaneComponent ],
    bootstrap:    []
})
export class SimpleIconsDashlaneModule {}
